var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDebankAppLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 4,
    fill: "#FE815F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1063 36.847C45.1063 42.5661 40.4005 47.2023 34.5957 47.2023H14.7422V40.2988H34.5957C36.5306 40.2988 38.0992 38.7534 38.0992 36.847C38.0992 34.9407 36.5306 33.3952 34.5957 33.3952H27.5886V26.4917H34.5957C36.5306 26.4917 38.0992 24.9463 38.0992 23.0399C38.0992 21.1335 36.5306 19.5881 34.5957 19.5881H14.7422V12.6846H34.5957C40.4005 12.6846 45.1063 17.3208 45.1063 23.0399C45.1063 25.6921 44.0943 28.1114 42.43 29.9435C44.0943 31.7755 45.1063 34.1948 45.1063 36.847Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7422 19.5881H31.7943C28.1722 15.3961 22.4054 12.6846 15.91 12.6846C15.518 12.6846 15.1286 12.6944 14.7422 12.7139V19.5881ZM35.3664 33.3952H28.7564V26.4916H35.3664C35.6268 27.6069 35.7635 28.7613 35.7635 29.9434C35.7635 31.1255 35.6268 32.2799 35.3664 33.3952ZM14.7422 40.2988H31.7943C28.1722 44.4908 22.4054 47.2024 15.91 47.2024C15.518 47.2024 15.1286 47.1925 14.7422 47.173V40.2988Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7422 12.6846C24.417 12.6846 32.26 20.4116 32.26 29.9435C32.26 39.4753 24.417 47.2023 14.7422 47.2023V40.2988C20.5471 40.2988 25.2529 35.6626 25.2529 29.9435C25.2529 24.2244 20.5471 19.5881 14.7422 19.5881V12.6846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebankAppLogin);
export default __webpack_public_path__ + "static/media/debank-app-login.498ad8e68c64134bfa3e25b834ebf62d.svg";
export { ForwardRef as ReactComponent };